function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { Constants } from '@shared/utils/constants';
import { logError } from '@shared/utils/httpClientUtil';
import { getAppConfig } from '@shared/services/init/appConfig';
import { logger } from '@src/logger';
import * as httpProtocol from './httpProtocol';
export function getProduct(productId, hideKey, market = 'US') {
    const endpoint = `${getAppConfig('MPRPHost')}/offers/${productId}`;
    const options = {
        requireCorrelationId: true,
        stringifyPostData: false,
        allowOrigin: true,
        authenticationType: httpProtocol.AuthenticationTypes.Unauthenticated,
        returnRawResponse: false
    };
    const get = httpProtocol.get(endpoint, options);
    if (hideKey) {
        get.addQueryEntry(`${Constants.QueryStrings.hideKeys}[0]`, hideKey);
    }
    return get.addQueryEntry(Constants.QueryStrings.apiVersion, Constants.mprpApiVersion).addQueryEntry(Constants.QueryStrings.market, market).request().catch((error)=>{
        logError('getProductById', error);
        logger.error('getProductById', {
            action: Constants.Telemetry.Action.GetProduct,
            actionModifier: Constants.Telemetry.ActionModifier.Error,
            error
        });
        return Promise.reject(error);
    });
}
export const getProductsBatch = ({ productsIds, hideKey, market = 'US' })=>_async_to_generator(function*() {
        return Promise.all(productsIds.map((productId)=>getProduct(productId, hideKey, market))).catch((error)=>{
            logError('getProductsBatch', error);
            logger.error('getProductsBatch', {
                action: Constants.Telemetry.Action.getProductsBatch,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                error
            });
            return Promise.reject(error);
        });
    })();
export const getProductsPricing = ({ productsBigIds, includeTestProducts, hideKey, market = 'US' })=>_async_to_generator(function*() {
        const BATCH_SIZE = 30;
        const endpoint = `${getAppConfig('MPRPHost')}/products`;
        const options = {
            authenticationType: httpProtocol.AuthenticationTypes.Unauthenticated,
            retry: 2
        };
        // Helper function to create a request for a batch of bigIds
        const createBatchRequest = (batchIds)=>_async_to_generator(function*() {
                const filterQuery = `bigId in (${batchIds.map((id)=>`'${id}'`).join(',')})`;
                const query = {
                    market: market.toUpperCase(),
                    $filter: filterQuery,
                    $select: 'startingPrice,legacyId,bigId',
                    $expand: 'startingPrice',
                    [Constants.QueryStrings.apiVersion]: Constants.mprpApiVersion,
                    storefront: 'any'
                };
                if (hideKey) {
                    query[`${Constants.QueryStrings.hideKeys}[0]`] = hideKey;
                }
                if (includeTestProducts) {
                    query[Constants.QueryStrings.includeTestProducts] = 'true';
                }
                const searchParams = new URLSearchParams(query);
                const get = httpProtocol.get(`${endpoint}?${searchParams.toString()}`, options);
                return get.request();
            })();
        // Split productsBigIds into batches of 60
        const batches = [];
        for(let i = 0; i < productsBigIds.length; i += BATCH_SIZE){
            batches.push(productsBigIds.slice(i, i + BATCH_SIZE));
        }
        try {
            // Execute all batch requests in parallel
            const batchResponses = yield Promise.all(batches.map((batch)=>createBatchRequest(batch)));
            // Merge all responses into a single response
            const mergedResponse = {
                items: batchResponses.flatMap((response)=>response.items || [])
            };
            logger.info(`getProductsPricing completed ${JSON.stringify({
                totalProducts: productsBigIds.length,
                batchCount: batches.length,
                resultsCount: mergedResponse.items.length
            })}`, {
                action: Constants.Telemetry.Action.GetProductsPricing,
                actionModifier: Constants.Telemetry.ActionModifier.Info
            });
            return mergedResponse;
        } catch (error) {
            logError('getProductsPricing', error);
            logger.error('getProductsPricing', {
                action: Constants.Telemetry.Action.GetProductsPricing,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                error
            });
            throw error;
        }
    })();
